import { motion } from "framer-motion";
import { fadeUp, slideRight, slideLeft } from "../../animations/variants";
import ScrollDown from "../../Layout/ScrollDown";

import { useSelector } from "react-redux";
import { heroText } from "i18n/hero";

const Hero = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = heroText[lang];
  return (
    <section className="pt-28 pb-20 bg-darkbg px-6 text-white overflow-hidden">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center">
        {/* SCROLL DOWN — MOBILE SAFE */}

        <motion.div
          variants={slideLeft}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="text-center md:text-left h-screen"
        >
          <motion.h1
            variants={fadeUp}
            className="font-heading text-4xl md:text-4xl lg:text-4xl leading-tight text-neonYellow "
          >
            {t.title.line1}
            <br />
            {t.title.line2}
            <br />
          </motion.h1>

          <motion.div
            variants={fadeUp}
            className="mt-10 w-[260px] md:w-[300px] mx-auto md:mx-0 overflow-hidden rounded-b-full"
          >
            <img
              src="/images/tb15.jpg"
              className="w-full h-full object-cover"
            />
          </motion.div>

          <motion.p
            variants={fadeUp}
            className="mt-8 text-xl md:text-2xl text-text font-heading leading-snug max-w-md mx-auto md:mx-0"
          >
            {t.description}
          </motion.p>
        </motion.div>
        {/* RIGHT */}
        <motion.div
          variants={slideRight}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="flex flex-col items-center md:items-end h-screen"
        >
          <img
            src="/images/tb4.jpg"
            className="w-full max-w-md object-cover rounded-lg grayscale mt-10 xs:mt-0"
          />

          <p className="text-sm text-text mt-3 font-medium">{t.intro}</p>
          <div className="w-32 border-b border-gray-600 mt-2"></div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
